<template>
	<section id="devis" class="item">
		<div class="container">
			<h2 class="text-center">Inscrire une copropriété</h2>
			<p class="text-center mb-5">Renseignez votre copropriété pour accéder à l'ensemble des fonctionnalités.</p>
<!--      , sans restriction, sans contrepartie-->
<!--      <p>Le nombre de lots principaux de votre copropriété permet de déterminer votre tarif.</p>-->
<!--				Vous aurez mensuelle sans engagement ou annuelle,-->
<!--				est fixé en fonction du-->

			<div class="row flex-column-reverse flex-sm-row">
<!--				<div class="col-lg-4 mt-3 mt-sm-0">-->
<!--					<div class="prix overflow-hidden text-center mb-lg-2" :class="{'scroll-visible':(scroll.y >= (scroll.devis - scroll.h/2)) && (scroll.y < (scroll.devis + scroll.dh - scroll.h/2))}">-->
<!--						<div class="row-fluid">-->
<!--							<div class="ici col-12 col-sm-10 offset-sm-1">-->

<!--								<template v-if="form.nb && form.produits.length>0">-->
<!--									<h2 v-if="form.engagement"><montant :montant="total_abt"></montant> annuel</h2>-->
<!--									<h2 v-else><montant :montant="total_abt"></montant> par&nbsp;mois</h2>-->

<!--									<div class="date mt-lg-4">-->
<!--										<template v-if="form.engagement">Engagement du&nbsp;<date :date="new Date().toISOString().substr(0,10)" /> au&nbsp;<date :date="new Date(-->
<!--										new Date(new Date().setMonth(new Date().getMonth()+12)).setDate(new Date().getDate()-1)-->
<!--									).toISOString().substr(0,10)" />.</template>-->
<!--										<template v-else>Sans engagement de&nbsp;durée.</template>-->
<!--									</div>-->

<!--									<div class="cgv small mt-lg-2">-->
<!--										&lt;!&ndash;									En passant commande, &ndash;&gt;-->
<!--										Vous confirmez avoir lu et acceptez-->
<!--										les-->
<!--										<router-link to="/documents/conditions-generales.pdf" target="_blank" rel="nofollow noopener" aria-label="Conditions d'utilisation" class="btn-link-white">conditions générales</router-link>-->
<!--										<span class="hidden-xs"> de <a :href="env.VUE_APP_VITRINE" target="_blank" rel="noopener" class="btn-link">CoproPrivée</a></span>.-->
<!--									</div>-->
<!--								</template>-->
<!--								<h2 v-else-if="send.devis" style="margin:50px 0">Votre devis vous sera adressé par mail dans quelques minutes. Merci !</h2>-->
<!--								<h2 v-else-if="send.commande" style="margin:50px 0">Merci ! Votre commande va être traitée prochainement. Un mail vous sera adressé dans les prochaines minutes.</h2>-->

<!--								<h3 v-else-if="form.produits.length===0" class="empty">Sélectionnez une formule d'abonnement pour obtenir votre devis.</h3>-->
<!--								<h3 v-else class="empty">Indiquez le nombre de lots de la copropriété pour obtenir votre devis.</h3>-->

<!--								<div v-if="(form.nb && form.produits.length>0) || form.message" class="btns mt-1 mt-lg-4">-->
<!--									<download-btn-->
<!--										@click="commande"-->
<!--										v-if="form.nb && form.produits.length>0"-->
<!--										:text="['Passer', 'Ma commande']"-->
<!--										:textxs="['Passer', 'Commande']"-->
<!--										classes="hover-active noresp" />-->
<!--									&lt;!&ndash;									icon="building"&ndash;&gt;-->
<!--									<download-btn-->
<!--										@click="devis"-->
<!--										v-if="form.nb && form.produits.length>0"-->
<!--										:text="['Obtenir','Mon devis']"-->
<!--										classes="hover-active noresp" />-->
<!--									&lt;!&ndash;									icon="file-invoice"&ndash;&gt;-->
<!--									<download-btn-->
<!--										@click="sendMessage"-->
<!--										v-if="form.message"-->
<!--										:text="['Envoyer','Mon message']"-->
<!--										classes="hover-active noresp" />-->
<!--									&lt;!&ndash;		icon=" fas fa-comment-alt-lines"&ndash;&gt;-->
<!--								</div>-->

<!--								<div v-if="callback && callback.message" :class="'text '+(callback.save ? '':'text-warning')+' mt-2'">-->
<!--									{{callback.message}}-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
				<div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
					<vue-form>
<!--						<div class="row">-->
<!--							<div class="col-12 col-sm-6">-->
<!--								<div class="btn-select2 mb-2 mb-sm-4" :class="{active:form.engagement===0}" @click="setAbonnement(0)">-->
<!--									<div class="body">-->
<!--										<div class="abt-titre">Abonnement mensuel</div>-->
<!--&lt;!&ndash;										<div class="abt-produit">&ndash;&gt;-->
<!--&lt;!&ndash;											<template v-if="produits"><montant :montant="produits['abo1m'].base" /> + <montant :montant="produits['abo1m'].variable" /> /lot</template>&ndash;&gt;-->
<!--&lt;!&ndash;											<template v-else>&nbsp;</template>&ndash;&gt;-->
<!--&lt;!&ndash;										</div>&ndash;&gt;-->
<!--										<div class="abt-detail">Sans engagement, l'arrêt des services est possible à chaque fin de mois !</div>-->
<!--									</div>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="col-12 col-sm-6">-->
<!--								<div class="btn-select2 mb-4" :class="{active:form.engagement===1}" @click="setAbonnement(1)">-->
<!--									<div class="body">-->
<!--										<div class="abt-titre">Abonnement annuel</div>-->
<!--&lt;!&ndash;										<div class="abt-produit">&ndash;&gt;-->
<!--&lt;!&ndash;											<template v-if="produits"><montant :montant="produits['abo12m'].base" /> + <montant :montant="produits['abo12m'].variable" /> /lot</template>&ndash;&gt;-->
<!--&lt;!&ndash;											<template v-else>&nbsp;</template>&ndash;&gt;-->
<!--&lt;!&ndash;										</div>&ndash;&gt;-->
<!--										<div class="abt-detail">Économisez 1 mois par rapport au paiement mensuel !</div>-->
<!--									</div>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->

						<vue-field v-model="form.nb"
											 type="number"
											 :min="2"
											 label="Nombre de lots dans la copropriété" />

<!--						<vue-field v-model="form.label"-->
<!--											 class="mb-4"-->
<!--											 placeholder="Nom de la copropriété, du syndicat ou de la résidence"-->
<!--											 required="required" />-->

						<vue-field type="adresse" class="mb-4" v-model="form.adresse" label="Adresse de la copropriété" />
<!--            , du syndicat ou de la résidence-->
						<div class="row">
							<div class="col-6">
								<vue-field v-model="form.interlocuteur.prenom" label="Prénom" required="required" />
							</div>
							<div class="col-6">
								<vue-field v-model="form.interlocuteur.nom" label="Nom" required="required" />
							</div>
						</div>
						<div class="row">
							<div class="col-sm-6 col-12">
								<vue-field type="email" v-model="form.interlocuteur.mail" label="Adresse email" required="required" />
							</div>
							<div class="col-sm-6 col-12">
								<vue-field type="tel" class="mb-4" v-model="form.interlocuteur.tel" label="Numéro de téléphone portable" />
							</div>
						</div>

						<!--											Indiquez le nombre de lots principaux dans la copropriété :-->
					<!--									placeholder="Vous pourrez changer le nombre de lots plus tard si nécessaire"-->

<!--							@adresse="onAdresse('adresse_facturation_id', $event)" -->
<!--							placeholder="Renseignez votre adresse de facturation"-->
<!--							class="mb-1" />-->
<!--						@input="form=Object.assign({},$event,{id:form.id, prenom:form.prenom, nom:form.nom, instruction:form.instruction, tva:form.tva, societe:form.societe, tel:form.tel})" -->
<!--						:fa="null" -->
<!--						:save="false"-->
<!--						:full="form.autocomplete" />-->
<!--						-->
<!--						<adresse-input :form="form"></adresse-input>-->

						<vue-field type="textarea" v-model="form.message" row="4" :toolbar="false" label="Votre éventuel message ..." />

						<div class="text-center">
							<download-btn
								@click="sendMessage"
								:disabled="!form.nb || !form.adresse.autocomplete || (!form.interlocuteur.mail && !form.interlocuteur.tel)"
								:text="['Valider mon','Inscription']"
								classes="hover-active noresp" />
						</div>

						<div v-if="callback && callback.message" :class="'mt-20 mb-0 alert '+(callback.save ? 'alert-success':'alert-warning')">
							{{callback.message}}
						</div>
					</vue-form>
				</div>
			</div>
<!--			<p>En attendant de vous permettre de créer votre formule nous vous avons besoin de votre aide.</p>-->
		</div>
	</section>
</template>
<style lang="scss" scoped>
	@import '../../src/assets/less/variables.scss';
	.btn-link-white{
		color: white;
		&:hover,
		&:focus{
			text-decoration: underline;
		}
	}
	.btn-select2 {
		vertical-align: middle;
		background: whitesmoke;
		cursor: pointer;
		border-radius: 8px;
		.body{
			padding: 3vh 2vw;
			text-align: center;

			@include smartphones(){
				padding-left: 15px;
				padding-right: 15px;
			}
			.abt-titre,
			.abt-produit{
				font-size: 20px;
				font-weight: 600;
				font-family: 'Montserrat', sans-serif;
				color: #2c3e50;
				display: block;
				line-height: 1.3em;
			}
			.abt-produit{
				font-size: 18px;
			}
			.abt-detail{
				margin-top: 1vh;
				font-size: 80%;
				line-height: 1.2em;
				color: #2c3e50;
			}
		}
		&.active {
			background: $primary-color-lighten;
		}
	}
	.prix {
		padding: 5vh 0;
		border-radius: 8px;

		background: linear-gradient(150deg, rgba(40, 20, 131, 0.76) 15%, rgba(143, 110, 213, 0.89) 70%, rgba(215, 130, 217, 0.74) 94%);

		position: sticky;
		top: 110px;
		/*bottom: 15px;*/

		@include smartphones(){
			border-radius: 0;
			position: fixed;
			top: initial;
			bottom: -150px;
			left: 0;
			right: 0;
			z-index: 2;
			padding: 2vh 0;

			-webkit-transition:all 0.5s ease-in-out;
			-moz-transition:all 0.5s ease-in-out;
			-o-transition:all 0.5s ease-in-out;
			-ms-transition:all 0.5s ease-in-out;
			transition:all 0.5s ease-in-out;


			-webkit-backdrop-filter: blur(1px);
			backdrop-filter: blur(1px);

			&.scroll-visible {
				-webkit-transform: translateY(-150px);
				-moz-transform: translateY(-150px);
				-ms-transform: translateY(-150px);
				transform: translateY(-150px);
			}

			h2{
				font-size: 18px;
				/*line-height: 23px;*/
				font-weight: 600;
			}
		}

		.ici *{
			color: white;
		}
		/*h2{*/
			/*line-height: 1em;*/
		/*}*/
		.date,
		.cgv{
			line-height: 1.2em;
		}

	}
</style>
<script>
	import Xhr from "../utils/Xhr";
	export default {
		metaInfo() {
			if(!this.meta) return {};
			return {
				title: 'Inscrire ma copropriété',
				meta: [
					{name: 'description', content: 'Un tarif simple et accessible, en fonction de la taille de votre copropriété. Tout est inclus.', id: 'desc'},
				]
			}
		},
		props:{
			meta: {default: true},
			token:{ default:null },
		},
		data:function(){
			return {
				form:{
					produits:['abo12m'],
					engagement:1,
					nb:null,
					// label:null,
					adresse: {},
					interlocuteur:{
						prenom:null,
						nom:null,
						mail:null,
						tel:null,
					},
					message:null,
				},
				produits:null,
				callback: null,
				send: {
					devis:null,
					commande:null
				},
			}
		},
		watch:{
			forms(){
				this.send.devis = null;
				this.send.commande = null;

				this.callback = null;
			}
		},
		created() {
			this.getProduits();

			if(this.$router.currentRoute.query.token){
				let token = this.$router.currentRoute.query.token;
				let base64 = window.atob(token);
				let json = base64 ? JSON.parse(base64) : null;
				if(json){
					this.form.interlocuteur = {
						prenom:json.p ? json.p : null,
						nom:json.n ? json.n : null,
						mail:json.m ? json.m : null,
						tel:json.t ? json.t : null,
					}
				}
			}
		},
		computed:{
			forms(){
				return JSON.stringify(this.form);
			},
			nb:function(){
				return Math.max(this.form.nb, 0);
			},
			total_abt:function(){
				return this.form.produits.reduce(function(total, produit_ref){
					let produit = this.produits[produit_ref];
					if(produit.abt){
						total+= parseInt(produit.base);
						if(produit.variable && this.nb){
							total+= this.nb * parseInt(produit.variable);
						}
					}
					return total;
				}.bind(this), 0);
			},
			message(){
				return "Bonjour,<br>"
					+ (this.form.adresse.autocomplete ? `Concernant la copropriété du ${this.form.adresse.autocomplete} ` : `Pour une copropriété `)
					+ (this.form.nb ? `possédant ${this.form.nb} lots` : `possédant plusieurs lots`)
					+ ',<br>'

					+ 'Je souhaite des informations sur un abonnement'
					+ (this.form.engagement===null ? '' : (this.form.engagement ? ' annuel':' mensuel'))
					+ (this.form.message ? ' :': '.')

					+ (this.form.message ? this.form.message : '')

					+ '<br>Cordialement.'
					// + (this.form.interlocuteur.prenom || this.form.interlocuteur.nom ? `${this.form.interlocuteur.prenom?this.form.interlocuteur.prenom:''} ${this.form.interlocuteur.nom?this.form.interlocuteur.nom:''}.<br>` : ``)
					// + (this.form.interlocuteur.tel ? `Téléphone : ${this.form.interlocuteur.tel}<br>` : ``)
					// + (this.form.interlocuteur.mail ? `Mail : ${this.form.interlocuteur.mail}` : ``);
			}
		},
		methods:{
			getProduits(){
				Xhr('GET', process.env.VUE_APP_VITRINE_API + 'vitrine/produits').then(function(data){
					this.produits = [];
					// let x = data.filter(p => p.Produit.ref==='abo1m' || p.Produit.ref==='abo12m').map(p => Object.assign({}, p.Produit, {abt:true}));
					// data = [
					// 	{Produit:{ref:'abo1m', label:'Abonnement mensuel', base:19, variable:5, abt:true, service:false, formation:false}},
					// 	{Produit:{ref:'abo12m', label:'Abonnement annuel', base:209, variable:55, abt:true, service:false, formation:false}},
					// ]

					for(let i=0; i<data.length; i++){
						let x = data[i];
						this.produits[ x.Produit.ref ] = Object.assign({}, x.Produit, {abt:true});
					}

				}.bind(this));
			},
			setAbonnement(value){
				if(this.form.engagement===value){
					this.form.engagement=null;
					this.form.produits=[];
				}else if(value===1){
					this.form.engagement=1;
					this.form.produits=['abo12m'];
				}else if(value===0){
					this.form.engagement=0;
					this.form.produits=['abo1m'];
				}
			},
			// commande: function(){
			// 	Xhr('POST', process.env.VUE_APP_VITRINE_API + 'commande', this.form).then(function(data){
			// 		this.callback = data;
			// 		if(data.save){
			// 			this.resetForm();
			// 			this.$nextTick(function(){
			// 				this.send.commande = true;
			// 			}.bind(this));
			// 		}
			// 	}.bind(this)).catch(function(data){
			// 		this.callback = data;
			// 	}.bind(this));
			// },
			// devis: function(){
			// 	Xhr('POST', process.env.VUE_APP_VITRINE_API + 'devis', this.form).then(function(data){
			// 		this.callback = data;
			// 		if(data.save){
			// 			this.resetForm();
			// 			this.$nextTick(function(){
			// 				this.send.devis = true;
			// 			}.bind(this));
			// 		}
			// 	}.bind(this)).catch(function(data){
			// 		this.callback = data;
			// 	}.bind(this));
			// },
			sendMessage: function(){
				Xhr('POST', process.env.VUE_APP_VITRINE_API + 'contact', Object.assign({}, this.form, {message:this.message})).then(function(data){
					if(data.save) this.resetForm();
          this.callback = data;
				}.bind(this)).catch(function(data){
					this.callback = data;
				}.bind(this)).then(function(data){
          this.callback = data;
        }.bind(this));
			},
			resetForm(){
				this.form = {
					produits:['abo12m'],
					engagement:1,
					nb:null,
					// label:null,
					adresse: {},
					interlocuteur:{
						prenom:null,
						nom:null,
						mail:null,
						tel:null,
					},
					message:null,
				}
			}
		},
	}
</script>
